import { useCallback, useState } from 'react';
import { StaticsApi } from '@/api/statics';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const useUpdateStatics = () => {
  const { showErrorToast, showSuccessToast } = usePopups();

  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = useCallback(async ({ id, file, text, text_RU, text_LV, type }) => {
    try {
      setIsUpdating(true);
      const res = await StaticsApi.updateStatics({ id, file, text, text_RU, text_LV, type });
      await queryClient.refetchQueries({ queryKey: ['StaticsApi.getStaticsAdmin'] });
      showSuccessToast('Saved');
      return res;
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsUpdating(false);
    }
  }, []);

  return {
    handleUpdate,
    isUpdating
  };
};
